import { registerSW } from 'virtual:pwa-register'
import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
import { useAppStore } from '@/stores/useAppStore'
import { useNotificationsStore } from '@/stores/useNotificationsStore'

export function useServiceWorker() {
  const newVersionPopup = useSpecificPopup('newVersion')

  let serviceWorkerRegistration: ServiceWorkerRegistration | undefined = undefined
  let isReloading = false

  const registerServiceWorker = () => {
    if ('serviceWorker' in navigator) {
      const updateWS = registerSW({
        onRegistered(swReg?: ServiceWorkerRegistration) {
          serviceWorkerRegistration = swReg
          const appStore = useAppStore()

          // Check for updates of the app every 10s. This is for users that leave it
          // running over long periods of time, so that the app updates itself if necessary.
          console.debug('onServiceWorkerRegistered', swReg)
          setInterval(() => {
            serviceWorkerRegistration?.update()
          }, 1000 * 10)

          if (!!serviceWorkerRegistration && 'pushManager' in serviceWorkerRegistration) {
            appStore.serviceWorkerRegistration = serviceWorkerRegistration

            // Wait for the service worker registration and getAppConfig to finish
            // before checking existing web push subscriptions.
            const checkInterval = setInterval(() => {
              if (appStore.appInitialized) {
                clearTimeout(checkInterval)
                useNotificationsStore().setupPushNotifications()
              }
            }, 1000)
          }
        },
        onRegisterError(error) {
          console.error('Service worker registration error:', error.message)
        },
        onNeedRefresh() {
          console.debug('New app version available')
          newVersionPopup.show()

          if (!isReloading) {
            isReloading = true
            setTimeout(() => {
              window.location.reload()
            }, 6000)
          }
        },
      });
    }
  }

  return {
    registerServiceWorker,
  }
}
